import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';
import withAnimation from '../../../../shared/components/utils/hoc/withAnimation';

const LanguagesContainer = styled.div`
  position: absolute;
  left: 0px;
  top: 0px;
  width: ${1000 * Screen.widthRatio}px;
  height: ${1000 * Screen.widthRatio}px;
  left: ${-675 * Screen.widthRatio}px;
`;

export default withAnimation(LanguagesContainer);
